import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const demo = async (params: object) => {
  return await GET({ url: Api.demo, params, showError: false })
}
